import React, { Fragment } from 'react'
import CreateNewPasswordPage from '../../Components/Auth/CreateNewPasswordPage'

const CreateNewPasswod = () => {
    return (
        <Fragment >
            <CreateNewPasswordPage />
        </Fragment>
    )
}

export default CreateNewPasswod